<template>
  <v-app
      id="app"
      class="noselect"
  >
    <router-view
        :language="language"
        :languages="languages"
        :theme="theme"
        :themes="themes"
    />
  </v-app>
</template>

<script>
    import i18n from "./i18n";

    export default {
        name: 'App',
        data() {
          return {
            language: 'english',
            languages: [
              {id: 'en', name: 'english'},
              {id: 'de', name: 'deutsch'},
              {id: 'ru', name: 'русский'},
            ],
            theme: 'Metal Blue',
            themes: [
                'Metal Blue',
                'Sunset',
                'Rainforest'
            ]
          }
        }
    };

    window.onbeforeunload = function(){
      if (window.showBeforeUnload) {
        return i18n.t('You may have unsaved changes. Consider saving them before you leave!');
      }
    };
</script>

<style lang="scss">
    @import "../public/css/main.css";
    @import "../public/css/data-table-styles.css";
    @import "../public/css/ribbon.css";
    @import "../public/css/materialdesignicons.min.css";
    @import "../public/css/snackbar.css";

    :root {
        --sc-blue:                  #355b7f;

        --main-header:              #46637f;
        --main-menu-background:     #d7dee5;
        --toolbar-background:       #c2cdd8;
        --toolbar-label:            #3C5976;   /* changed from #47698a because of better contrast sc blue 87% auf toolbar background */
        --toolbar-select-underline: #8ca1b6;   /* sc blue 38% */
        --toolbar-select-underline-disabled: #b3b3b3;   /* sc blue 38% */
        --toolbar-separator:        #b3c1cf;
        --table-header-background:  #cfd8df;   /* sc blue 20% */
        --table-header-border:      #a0b2c1;   /* sc blue 30% */
        --table-no-data-background: #F5F7F8;
        --table-no-data-color:      #00000091; /* black   57% */
        --sidebar-odd-background:   #eaeef2;   /* sc blue 10% */
        --selected-cell-background: #e1e7ec;
        --selected-cell-border:     #355b7f;

        --pagination-background:    #cfd8df;   /* sc blue 20% */
        --pagination-hover:         #bfcbd5;   /* sc blue ??% */
        --pagination-color:         #47698A;   /* changed from sc blue because of contrast */

        --sc-blue-light:            #ccd6df;
        --sc-blue-light-background: #e1e7ec;
        --sc-blue-dark:             #355b7f;
        --sc-blue-ribbon:           #67849f;
        --sc-blue-dark-5-percent:   #355b7f0d;

        --error-red:                #e94539;
        --error-dark-red:           #880000;
        --text-grey:                #777777;

        --text-dark:                #263239;

        /* unused */
        --success-green:            #00C000;
        --warning-yellow:           #e9ae39;

        --font-size-ribbon:       14px;
        --font-size-table-header: 14px;
        --font-size-table-data:   14px;
        --font-size-editor:       14px;
        --font-size-headline:     16px;
    }

    .noselect {
        -webkit-touch-callout: none; /* iOS Safari */
        -webkit-user-select: none; /* Safari */
        -khtml-user-select: none; /* Konqueror HTML */
        -moz-user-select: none; /* Old versions of Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
        user-select: none; /* Non-prefixed version, currently supported by Chrome, Edge, Opera and Firefox */
    }

    .center {
        text-align: center;
    }

    body {
        margin: 0;
    }

    #app {
        --unnamed-font-family-d-din: D-DIN;
        --unnamed-font-family-d-din-din: D-DIN DIN;
        --unnamed-font-style-regular: Regular;

        font-family: D-DIN, D-DIN DIN, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #000;
        margin: 0;
        height: 100vh;
        overflow: hidden;
    }
    #app > div.v-application--wrap > div {
      height: 100%;
      overflow: hidden;
      display: flex;
      flex-flow: column;
    }
    #app > div.v-application--wrap > div > div.home {
      flex-grow: 1;
      overflow: hidden;
      display: flex;
      flex-flow: column;
    }

    /* Vue Dialog - Confirm */
    div.v-overlay div.v-overlay_scrim {
      opacity: 0.25;
    }
    div.v-dialog {
      border-radius: 0;
      border: 2px solid var(--sc-blue-dark)
    }
    div.v-dialog div.v-card {
      border-radius: 0;
    }
    div.v-dialog div.v-card header div.v-toolbar__content div.v-toolbar__title {
      color: var(--toolbar-label)
    }
    div.v-dialog div.v-card div.v-card__text {
      font-size: 14px;
      color: black;
      text-align: left;
    }
    div.v-dialog div.v-card div.v-card__actions button {
      color: var(--toolbar-label)
    }

    /* center check boxes */
    .center .v-input__slot {
        align-items: center;
        justify-content: center;
    }

</style>
